import PropTypes from "prop-types";
import React from "react";
import Heading from "../../elements/heading";
import MultiColumn from "../multi-column";
import BodyText from "../../elements/body-text";
import "./style.scss";

export default function SimpleHero({
  titleType,
  titleBody,
  overline,
  body,
  backgroundImage
}) {
  let backgroundImageVal = backgroundImage ? backgroundImage.value.src : "";
  return (
    <div className="simple-hero">
      <MultiColumn backgroundImage={backgroundImageVal} type="grid">
        {overline && overline.value && (
        <BodyText
          className="simple-hero-overline"
          html={overline ? overline.value : ""}
        />
         )}
        <div className="simple-hero-heading">
          <Heading
            type={titleType}
            typographyClass="type-h1-big"
            html={titleBody}
          />
        </div>
        <BodyText className="simple-hero-body" html={body ? body.value : ""} />
      </MultiColumn>
    </div>
  );
}

SimpleHero.propTypes = {
  titleType: PropTypes.object,
  titleBody: PropTypes.object,
  overline: PropTypes.shape({ value: PropTypes.string }),
  body: PropTypes.shape({ value: PropTypes.string }),
  backgroundImage: PropTypes.shape({
    value: PropTypes.shape({ src: PropTypes.string })
  })
};
